import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { Form, Button, ButtonGroup, Modal } from 'react-bootstrap';
import { Select, CheckBox } from '../../../components/form';
import { connect } from 'react-redux';
import LanguageSelector from '../../partials/layout/LanguageSelector';
import InputField from '../../../components/form/InputField';
import FormGroup from '../../../components/form/FormGroup';
import CountriesList from '../users/countriesList';
import CurrencyList from '../users/CurrencyList';
import UIModal from '@material-ui/core/Modal';
import {
  authCurrentDefaultTypeSelecetor,
  authCurrentUserSettings,
  authCurrentUserTypeSelector,
  authUserIdSelector
} from '../../../modules/auth/Selectors';
import { updateCurrnetUserSettingsAction } from '../../../modules/auth/Actions';
import {
  getUserAction,
  updateUserAction,
  updateUserSettingsAction
} from '../../../modules/users/Actions';

import {
  userSettingsSelector,
  usersIsLoadingSelector
} from '../../../modules/users/Selectors';

import {
  createArtisanTagAction,
  updateArtisanTagAction,
  getArtisanTagsAction
} from '../../../modules/artisanTags/Actions';
import {
  artisanTagsIsLoadingSelector,
  artisanTagByIdSelector
} from '../../../modules/artisanTags/Selectors';
// import FormBIOi18n from '../../../components/form/i18nForm/FormBIOi18n';

import ArtisanForm from '../users/ArtisanForm';
import SupplierForm from '../users/SupplierForm';
import CustomerForm from '../users/CustomerForm';

import * as Yup from 'yup';
import ApplicantForm from '../users/ApplicantForm';
import getLangData from '../../../utils/getLangData';

const LangOptions = [
  { value: 'EN', label: 'English' },
  { value: 'AR', label: 'Arabic' }
];
// const usersOptions = [
// 	{ value: "4", label: "Artisan" },
// 	{ value: "5", label: "Supplier" },
// 	{ value: "6", label: "Customer" },
// ];
const schema = () =>
  Yup.object().shape({
    settingsDefaultCountry: Yup.string().default(''),
    settingsReceiveNotifications: Yup.bool().default(false),
    settingsDefaultCurrency: Yup.string().default(''),
    settingsUILanguage: Yup.string().default('EN')
  });

const UserSettings = props => {
  const {
    userId,
    userSettings,
    getUser,
    updateUser,
    isLoading,
    userType,
    userDefaultType,
    UpdateUserType
  } = props;
  const [modalOpen, setModelOpen] = useState(false);
  const [addType, setAddType] = useState('');
  const [formModal, setFormModal] = useState(null);
  const artisanFormNum = 1;
  const supplierFormNum = 2;
  const customerFormNum = 3;
  const applicantFormNum = 4;
  useEffect(() => {
    // console.log(userId);

    getUser(userId);

    // console.log(userSettings);
    console.log(userType);
  }, []);
  const openFormModal = () => {
    setFormModal();
  };
  const openModalHandler = type => {
    if (type !== localStorage.getItem('defaultType')) {
      setAddType(type);
      setModelOpen(true);
    }
  };
  const selectedForm = () => {
    console.log(formModal, 'formModal');
    if (formModal === 1)
      return <ArtisanForm reload={true} staging authId={userId} />;
    else if (formModal === 3) return <CustomerForm staging authId={userId} />;
    else if (formModal === 2) return <SupplierForm staging authId={userId} />;
    else if (formModal === applicantFormNum)
      return <ApplicantForm staging authId={userId} />;
    // return <div>applicant From</div>;
  };
  return (
    <>
      <Modal show={modalOpen} onHide={() => setModelOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to switch profile</Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setModelOpen(false)}>
            No
          </Button>
          <Button
            variant='primary'
            onClick={() => {
              localStorage.setItem('defaultType', addType);
              UpdateUserType(userId, { defaultUserType: addType });
              window.location.reload();
            }}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <Modal  show={formModal} onHide={()=> setFormModal(null)}>
          <Modal.Body >

            {  formModal && <div >{selectedForm()}</div> }
          </Modal.Body>
      </Modal> */}

      <UIModal
        // style={{
        //   width: '60%',
        //   backgroundColor: 'white',
        //   overflow: 'auto',
        //   top: '60%',
        //   left: '50%',
        //   transform: 'translate(-50%, -50%)',
        //   height: '100%',

        //   position: 'absolute',
        //   padding: '50px',
        // }}
        open={formModal}
        onClose={() => setFormModal(null)}
        closeAfterTransition
        BackdropProps={{
          timeout: 500
        }}
      >
        {formModal && (
          <div
            style={{
              width: '60%',
              backgroundColor: 'white',
              overflow: 'auto',
              top: '60%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              height: '100%',

              position: 'absolute',
              padding: '50px'
            }}
          >
            {selectedForm()}
          </div>
        )}
      </UIModal>
      {/* {userDefaultType !== '0' || userDefaultType !== '1' ? ( for testing TODO remove it */}
      {/* {userDefaultType !== '0' ? (
        <>
          {userType?.length > 1 ? <label>Switch Profiles:</label> : null}
          {userType?.length > 1 ? (
            <ButtonGroup className="ml-2">
              {userType.indexOf('0') !== -1 ? (
                <Button
                  onClick={() => openModalHandler('0')}
                  className="ml-1"
                  style={{
                    color:
                      localStorage.getItem('defaultType') === '0'
                        ? 'white'
                        : 'black',
                  }}
                >
                  Super Admin
                </Button>
              ) : null}
              {userType.indexOf('1') !== -1 ? (
                <Button
                  onClick={() => openModalHandler('0')}
                  className="ml-1"
                  style={{
                    color:
                      localStorage.getItem('defaultType') === '1'
                        ? 'white'
                        : 'black',
                  }}
                >
                  Admin
                </Button>
              ) : null}
              {userType.indexOf('3') !== -1 ? (
                <Button
                  onClick={() => openModalHandler('3')}
                  className="ml-1"
                  style={{
                    color:
                      localStorage.getItem('defaultType') === '3'
                        ? 'white'
                        : 'black',
                  }}
                >
                  Artisan
                </Button>
              ) : null}
              {userType.indexOf('4') !== -1 ? (
                <Button
                  onClick={() => openModalHandler('4')}
                  className="ml-1"
                  style={{
                    color:
                      localStorage.getItem('defaultType') === '4'
                        ? 'white'
                        : 'black',
                  }}
                >
                  Customer
                </Button>
              ) : null}
              {userType.indexOf('5') !== -1 ? (
                <Button
                  onClick={() => openModalHandler('5')}
                  className="ml-1"
                  style={{
                    color:
                      localStorage.getItem('userTypeNum') === '5'
                        ? 'white'
                        : 'black',
                  }}
                >
                  Supplier
                </Button>
              ) : null}
            </ButtonGroup>
          ) : null}
        </>
      ) : (
        <></>
      )} */}

      <Formik
        initialValues={userId ? userSettings : schema().cast()}
        // initialValues={schema().cast()}
        enableReinitialize={true}
        isLoading={isLoading}
        onSubmit={values => {
          // const data = {
          //   settingsDefaultCountry: values.settingsDefaultCountry,
          //   settingsReceiveNotifications: values.settingsReceiveNotifications,
          //   settingsDefaultCurrency: values.settingsDefaultCurrency,
          //   settingsUILanguage: values.settingsUILanguage,
          // };
          console.log(values, userId);
          updateUser({ userId, values });
        }}
      >
        {({ handleSubmit, setFieldValue, values }) => (
          <FormGroup
            enableReinitialize
            isLoading={isLoading}
            handleSubmit={handleSubmit}
            heading={getLangData().menu.side.settings}
          >
            <CheckBox
              name='settingsReceiveNotifications'
              label={getLangData().fields.notification}
            />

            {/* <Select
              label={getLangData().fields.country}
              name='settingsDefaultCountry'
              value={values.settingsDefaultCountry}
              // value={CountriesList.filter((object) => {
              //   // console.log(values);

              //   return values.settingsDefaultCountry.indexOf(object.value) > -1;
              // })}
              options={CountriesList}
              onChange={value => {
                setFieldValue(
                  'settingsDefaultCountry',
                  value.settingsDefaultCountry
                );
              }}
            /> */}

            <Select
              label={getLangData().fields.currency}
              name='settingsDefaultCurrency'
              value={values.settingsDefaultCurrency}
              // value={CurrencyList.filter(
              //   (object) =>
              //     values.settingsDefaultCurrency.indexOf(object.value) > -1
              // )}
              options={CurrencyList}
              // onChange={(value) => {
              //   setFieldValue(
              //     'settingsDefaultCurrency',
              //     value.settingsDefaultCurrency
              //   );
              // }}
            />
            {/* <div style={{maxWidth: '40px'}}>
            <LanguageSelector />
          </div> */}
            <Select
              label={getLangData().fields.languages}
              name='settingsUILanguage'
              value={values.settingsUILanguage}
              options={LangOptions}
              onChange={e => {
                setFieldValue(e);
              }}
            />
          </FormGroup>
        )}
      </Formik>
      {/* {userDefaultType !== '0' ? (
        <>
          {userType.length > 1 ? <label>Switch Profiles:</label> : null}
          {userType.length > 1 ? (
            <ButtonGroup className='ml-2'>
              {userType.indexOf('0') !== -1 ? (
                <Button
                  onClick={() => openModalHandler('0')}
                  className='ml-1'
                  style={{
                    color:
                      localStorage.getItem('defaultType') === '0'
                        ? 'white'
                        : 'black'
                  }}
                >
                  Super Admin
                </Button>
              ) : null}
              {userType.indexOf('1') !== -1 ? (
                <Button
                  onClick={() => openModalHandler('0')}
                  className='ml-1'
                  style={{
                    color:
                      localStorage.getItem('defaultType') === '1'
                        ? 'white'
                        : 'black'
                  }}
                >
                  Admin
                </Button>
              ) : null}
              {userType.indexOf('3') !== -1 ? (
                <Button
                  onClick={() => openModalHandler('3')}
                  className='ml-1'
                  style={{
                    color:
                      localStorage.getItem('defaultType') === '3'
                        ? 'white'
                        : 'black',
                    borderRadius: '0px'
                  }}
                >
                  Artisan
                </Button>
              ) : (
                <Button
                  onClick={() => setFormModal(artisanFormNum)}
                  className='ml-1'
                  style={{
                    borderRadius: '0px'
                  }}
                >
                  Add Artisan
                </Button>
              )}
              {userType.indexOf('4') !== -1 ? (
                <Button
                  onClick={() => openModalHandler('4')}
                  className='ml-1'
                  style={{
                    color:
                      localStorage.getItem('defaultType') === '4'
                        ? 'white'
                        : 'black'
                  }}
                >
                  Customer
                </Button>
              ) : (
                <Button
                  onClick={() => setFormModal(customerFormNum)}
                  className='ml-1'
                  // style={{
                  //   color:
                  //     localStorage.getItem('defaultType') === '4'
                  //       ? 'white'
                  //       : 'black',
                  // }}
                >
                  Add Customer
                </Button>
              )}
              {userType.indexOf('5') !== -1 ? (
                <Button
                  onClick={() => openModalHandler('5')}
                  className='ml-1'
                  style={{
                    color:
                      localStorage.getItem('userTypeNum') === '5'
                        ? 'white'
                        : 'black',
                    borderRadius: '0px'
                  }}
                >
                  Supplier
                </Button>
              ) : (
                <Button
                  onClick={() => setFormModal(supplierFormNum)}
                  className='ml-1'
                  // style={{
                  //   color:
                  //     localStorage.getItem('userTypeNum') === '5'
                  //       ? 'white'
                  //       : 'black',
                  // }}
                >
                  Add Supplier
                </Button>
              )}

              {userType.indexOf('6') !== -1 ? (
                <Button
                  onClick={() => openModalHandler('6')}
                  className='ml-1'
                  style={{
                    color:
                      localStorage.getItem('userTypeNum') === '6'
                        ? 'white'
                        : 'black',
                    borderRadius: '0px'
                  }}
                >
                  Applicant
                </Button>
              ) : (
                <Button
                  onClick={() => setFormModal(applicantFormNum)}
                  className='ml-1'
                  // style={{
                  //   color:
                  //     localStorage.getItem('userTypeNum') === '5'
                  //       ? 'white'
                  //       : 'black',
                  // }}
                >
                  Add Applicant
                </Button>
              )}
            </ButtonGroup>
          ) : null}
        </>
      ) : (
        <></>
      )} */}
    </>
  );
};

const mapStateToProps = (state, props) => {
  // const userId = props.match.params.id;
  return {
    userId: authUserIdSelector(state),
    isLoading: usersIsLoadingSelector(state),
    artisanTag: artisanTagByIdSelector(state),
    // userSettings: userSettingsSelector(state),
    userSettings: authCurrentUserSettings(state),
    userType: authCurrentUserTypeSelector(state),
    userDefaultType: authCurrentDefaultTypeSelecetor(state)
  };
};

export default connect(mapStateToProps, {
  getUser: getUserAction,
  updateUser: updateCurrnetUserSettingsAction,
  // updateUser: updateUserSettingsAction,
  getArtisanTags: getArtisanTagsAction,
  createArtisanTag: createArtisanTagAction,
  updateArtisanTag: updateArtisanTagAction,
  UpdateUserType: updateUserAction
})(UserSettings);
